import { styled } from '@/shared/ui';

export const StyledBox = styled('div')`
  height: 100%;
  min-height: 600px;

  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

export const StyledText = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  max-width: 640px;

  font-weight: 400;
`;

export const StyledIconWrap = styled('div')`
  color: #1a8f4c;

  svg {
    width: 64px;
    height: 64px;
  }
`;

export const StyledOops = styled('div')`
  font-size: 45px;
`;
